import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-ae05d9ee"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["element-loading-spinner"];
const _hoisted_2 = {
  class: "out_box"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "1rem",
    "cursor": "pointer"
  }
}, "返回", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title_box"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "catalog"
}, "目录")], -1));

const _hoisted_5 = {
  style: {
    "overflow": "auto"
  },
  ref: "treeBox"
};
const _hoisted_6 = ["onDblclick"];
const _hoisted_7 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "center"
  }
};
const _hoisted_8 = {
  key: 0,
  style: {
    "user-select": "none",
    "font-size": ".8rem",
    "font-weight": "bold",
    "max-width": "15rem",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_9 = ["onUpdate:modelValue", "onBlur", "onKeyup"];
const _hoisted_10 = {
  key: 0,
  style: {
    "color": "red",
    "margin-left": ".2rem",
    "font-size": ".8rem",
    "font-weight": "bold"
  }
};
const _hoisted_11 = {
  style: {
    "color": "red",
    "font-weight": "bold",
    "user-select": "none",
    "font-size": ".8rem"
  }
};
const _hoisted_12 = {
  class: "out_box"
};
const _hoisted_13 = {
  style: {
    "display": "flex",
    "width": "100%",
    "padding": "0 1rem 0 0",
    "align-items": "center"
  }
};
const _hoisted_14 = {
  style: {
    "font-weight": "bold",
    "user-select": "none"
  }
};
const _hoisted_15 = {
  style: {
    "user-select": "none",
    "max-width": "15rem",
    "overflow": "hidden",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_16 = {
  class: "problem_box"
};
const _hoisted_17 = {
  key: 0,
  class: "content_box"
};
const _hoisted_18 = {
  class: "question_box",
  ref: "scrollRef"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_tree = _resolveComponent("el-tree");

  const _directive_focus = _resolveDirective("focus");

  const _directive_loading = _resolveDirective("loading");

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "main",
    "element-loading-text": "Loading...",
    "element-loading-spinner": $data.svg,
    "element-loading-svg-view-box": "-10, -10, 50, 50",
    "element-loading-background": "rgba(122, 122, 122, 0.8)"
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    style: {
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.clickReturn())
  }, [_createVNode(_component_van_icon, {
    size: "20",
    name: "arrow-left"
  }), _hoisted_3]), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tree, {
    ref: "treeList",
    "highlight-current": true,
    "expand-on-click-node": false,
    "node-key": "id",
    "current-node-key": $data.hightLightNode,
    data: $data.treeListData,
    props: $data.defaultProps,
    "default-expanded-keys": $data.currentNodeIds,
    onNodeClick: $options.clickColumnData
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", {
      onDblclick: $event => $options.startEditing(data),
      style: {
        "display": "flex",
        "justify-content": "space-between",
        "width": "100%",
        "padding": "0 1rem 0 0",
        "align-items": "center"
      }
    }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_tooltip, {
      content: data.name,
      placement: "right",
      effect: "customized",
      "show-after": 500,
      enterable: false
    }, {
      default: _withCtx(() => [!$data.editObj[data.id] ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(data.name), 1)) : _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 1,
        ref: "editInput",
        "onUpdate:modelValue": $event => data.name = $event,
        onBlur: $event => $options.handleBlur($event, data),
        onKeyup: _withKeys(_withModifiers($event => $options.endEditing(data), ["prevent"]), ["enter"]),
        style: {
          "height": "1rem",
          "padding": ".5rem .2rem",
          "border-radius": ".2rem"
        }
      }, null, 40, _hoisted_9)), [[_directive_focus], [_vModelText, data.name]])]),
      _: 2
    }, 1032, ["content"]), data.id != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_10, "(" + _toDisplayString(data.sopSumNum) + ")", 1)) : _createCommentVNode("", true)]), _createElementVNode("p", _hoisted_11, _toDisplayString(data.sumNum), 1)], 40, _hoisted_6)]),
    _: 1
  }, 8, ["current-node-key", "data", "props", "default-expanded-keys", "onNodeClick"])], 512)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_tree, {
    ref: "questionRef",
    "node-key": "id",
    data: $options.questionList,
    props: $data.questionDefaultProps,
    "highlight-current": "",
    onNodeClick: $options.clickQuestionList
  }, {
    default: _withCtx(({
      node,
      data
    }) => [_createElementVNode("div", _hoisted_13, [_createElementVNode("p", _hoisted_14, _toDisplayString(data.order_no) + ".", 1), _createVNode(_component_el_tooltip, {
      content: data.label,
      placement: "right",
      effect: "customized",
      "show-after": 500,
      enterable: false
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_15, _toDisplayString(data.label), 1)]),
      _: 2
    }, 1032, ["content"])])]),
    _: 1
  }, 8, ["data", "props", "onNodeClick"])]), _createElementVNode("div", _hoisted_16, [$data.questionId ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, null, 512)])) : _createCommentVNode("", true)])], 8, _hoisted_1)), [[_directive_loading, $data.loading]]);
}